(function () {
  var DEBUG_SOURCE = 'upcart-price-order';

  function getDebugState(extra) {
    var drawer = document.querySelector('cart-drawer');
    return Object.assign({
      source: DEBUG_SOURCE,
      href: window.location.href,
      pathname: window.location.pathname,
      shopifyRoot: window.Shopify?.routes?.root,
      bodyClass: document.body?.className,
      bodyOverflowStyle: document.body?.style?.overflow,
      bodyOverflowComputed: document.body ? window.getComputedStyle(document.body).overflow : null,
      upcartOpenCartType: typeof window.upcartOpenCart,
      upcartRefreshCartType: typeof window.upcartRefreshCart,
      hasUpcartSettings: Boolean(window.upcartSettings),
      upcartCartIsEnabled: window.upcartSettings?.upcartEditorSettings?.cartIsEnabled,
      hasThemeDrawer: Boolean(drawer),
      themeDrawerClass: drawer?.className || null,
      themeDrawerHidden: drawer?.getAttribute('aria-hidden') || null,
      hasPompeiiOpenUpcart: typeof window.pompeiiOpenUpcart === 'function',
    }, extra || {});
  }

  function debugLog(step, extra) {
    console.log('[DLM Upcart Debug]', step, getDebugState(extra));
  }

  debugLog('script:start', {
    alreadyInitialized: Boolean(window.__pompeiiUpcartIntegrationInit),
    scripts: Array.from(document.scripts)
      .map(function (script) { return script.src; })
      .filter(function (src) { return /upcart|cart-drawer/i.test(src); }),
  });

  if (window.__pompeiiUpcartIntegrationInit) {
    debugLog('script:skip-already-initialized');
    return;
  }
  window.__pompeiiUpcartIntegrationInit = true;
  var isOpeningUpcart = false;

  function cartRoute(path) {
    var root = window.Shopify?.routes?.root || '/';
    var normalizedRoot = root.endsWith('/') ? root : root + '/';
    return normalizedRoot + String(path || '').replace(/^\/+/, '');
  }

  function isCartLink(link) {
    if (!link || !link.getAttribute('href')) return false;

    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      return url.origin === window.location.origin && /\/cart\/?$/.test(url.pathname);
    } catch {
      return false;
    }
  }

  function shouldUseUpcart() {
    var result = Boolean(
      typeof window.upcartOpenCart === 'function' ||
        (window.upcartSettings?.upcartSettings && window.upcartSettings?.upcartEditorSettings?.cartIsEnabled !== false)
    );

    debugLog('shouldUseUpcart', { result: result });
    return result;
  }

  function clearThemeCartState() {
    debugLog('clearThemeCartState:before');

    document.body.classList.remove('cart-drawer-open');
    document.body.style.overflow = '';

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    debugLog('clearThemeCartState:after');
  }

  function waitForUpcartApi(timeout) {
    debugLog('waitForUpcartApi:start', { timeout: timeout });

    if (typeof window.upcartOpenCart === 'function') {
      debugLog('waitForUpcartApi:ready-immediate');
      return Promise.resolve(true);
    }

    return new Promise(function (resolve) {
      var startedAt = Date.now();
      var timer = window.setInterval(function () {
        if (typeof window.upcartOpenCart === 'function') {
          window.clearInterval(timer);
          debugLog('waitForUpcartApi:ready-after-wait', { elapsed: Date.now() - startedAt });
          resolve(true);
          return;
        }

        if (Date.now() - startedAt >= timeout) {
          window.clearInterval(timer);
          debugLog('waitForUpcartApi:timeout', { elapsed: Date.now() - startedAt });
          resolve(false);
        }
      }, 50);
    });
  }

  async function openUpcart() {
    debugLog('openUpcart:start', { isOpeningUpcart: isOpeningUpcart });

    if (isOpeningUpcart) {
      debugLog('openUpcart:skip-already-opening');
      return;
    }

    isOpeningUpcart = true;
    clearThemeCartState();

    try {
      var ready = await waitForUpcartApi(4000);
      if (!ready) {
        debugLog('openUpcart:fallback-to-cart-page');
        window.location.href = cartRoute('cart');
        return;
      }

      if (typeof window.upcartRefreshCart === 'function') {
        debugLog('openUpcart:refresh-start');
        await window.upcartRefreshCart()
          .then(function () { debugLog('openUpcart:refresh-success'); })
          .catch(function (error) { debugLog('openUpcart:refresh-error', { error: String(error) }); });
      }

      clearThemeCartState();
      debugLog('openUpcart:calling-window-upcartOpenCart');
      window.upcartOpenCart();
      debugLog('openUpcart:called-window-upcartOpenCart');
    } catch (error) {
      debugLog('openUpcart:error', { error: String(error), stack: error?.stack });
    } finally {
      isOpeningUpcart = false;
      debugLog('openUpcart:finish');
    }
  }

  function initThemeDrawerGuard() {
    if (!document.body) {
      debugLog('themeDrawerGuard:no-body');
      return;
    }

    debugLog('themeDrawerGuard:init');

    var observer = new MutationObserver(function () {
      debugLog('themeDrawerGuard:body-class-change');

      if (document.body.classList.contains('cart-drawer-open') && shouldUseUpcart()) {
        debugLog('themeDrawerGuard:theme-drawer-open-detected');
        void openUpcart();
      }
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-cart-toggle], a[href]');
    if (!opener) return;
    if (!opener.matches('[data-cart-toggle]') && !isCartLink(opener)) return;

    debugLog('click:capture-cart-opener', {
      openerTag: opener.tagName,
      openerHref: opener.getAttribute('href'),
      openerClass: opener.className,
      hasDataCartToggle: opener.matches('[data-cart-toggle]'),
      defaultPreventedBefore: event.defaultPrevented,
    });

    if (!shouldUseUpcart()) {
      debugLog('click:capture-skip-upcart-disabled');
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    debugLog('click:capture-open-upcart');
    void openUpcart();
  }, true);

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    debugLog('submit:capture-cart-add', {
      action: form.getAttribute('action'),
      method: form.getAttribute('method'),
      defaultPreventedBefore: event.defaultPrevented,
    });

    if (!shouldUseUpcart()) {
      debugLog('submit:capture-skip-upcart-disabled');
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    debugLog('submit:capture-posting-cart-add');

    try {
      var response = await fetch(cartRoute('cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      debugLog('submit:capture-cart-add-response', {
        ok: response.ok,
        status: response.status,
        statusText: response.statusText,
      });

      if (!response.ok) throw new Error('add failed');

      document.dispatchEvent(new CustomEvent('cart:updated'));
      await openUpcart();
    } catch (error) {
      debugLog('submit:capture-error', { error: String(error), stack: error?.stack });
      console.error('[upcart-integration]', error);
      form.submit();
    }
  }, true);

  if (document.body) {
    initThemeDrawerGuard();
  } else {
    document.addEventListener('DOMContentLoaded', initThemeDrawerGuard, { once: true });
  }

  window.pompeiiOpenUpcart = openUpcart;
  debugLog('script:ready');
})();

(function () {
  var MONEY_PATTERN = '((?:\\d{1,3}(?:\\.\\d{3})*|\\d+)[,.]\\d{2})\\s*\\u20ac';
  var PRICE_SEQUENCE = new RegExp(MONEY_PATTERN + '\\s*' + MONEY_PATTERN + '\\s*(\\((?:Ahorra|Save|Savings)[^)]+\\))', 'i');

  function parseMoney(text) {
    var match = String(text || '').match(new RegExp(MONEY_PATTERN, 'i'));
    return match ? parseFloat(match[1].replace(/\./g, '').replace(',', '.')) : null;
  }

  function looksLikeSavings(text) {
    return /ahorra|save|savings|discount/i.test(String(text || ''));
  }

  function makePriceSpan(text, attribute) {
    var span = document.createElement('span');
    span.textContent = text.trim();
    span.setAttribute(attribute, 'true');
    return span;
  }

  function rewriteInlinePriceText(textNode) {
    var text = textNode.nodeValue;
    var match = text.match(PRICE_SEQUENCE);

    if (!match || textNode.parentElement.dataset.delamurPriceSorted === 'true') return false;

    var firstPrice = match[1] + ' \u20ac';
    var secondPrice = match[2] + ' \u20ac';
    var saving = match[3];
    var firstValue = parseMoney(firstPrice);
    var secondValue = parseMoney(secondPrice);
    var currentPrice = firstValue <= secondValue ? firstPrice : secondPrice;
    var comparePrice = firstValue <= secondValue ? secondPrice : firstPrice;
    var before = text.slice(0, match.index);
    var after = text.slice(match.index + match[0].length);
    var row = document.createElement('span');

    row.setAttribute('data-delamur-price-row', 'true');
    row.appendChild(makePriceSpan(currentPrice, 'data-delamur-current-price'));
    row.appendChild(makePriceSpan(comparePrice, 'data-delamur-compare-price'));
    row.appendChild(makePriceSpan(saving, 'data-delamur-saving-price'));

    var fragment = document.createDocumentFragment();
    if (before) fragment.appendChild(document.createTextNode(before));
    fragment.appendChild(row);
    if (after) fragment.appendChild(document.createTextNode(after));

    textNode.parentNode.replaceChild(fragment, textNode);
    row.parentElement.dataset.delamurPriceSorted = 'true';
    return true;
  }

  function sortPriceNodes(row) {
    if (!row || row.dataset.delamurPriceSorted === 'true') return;

    var nodes = Array.from(row.children).filter(function (node) {
      return node.textContent && node.textContent.match(/\d+[,.]\d{2}\s*\u20ac|ahorra|save|savings/i);
    });

    if (nodes.length < 2) return;

    var moneyNodes = nodes.filter(function (node) {
      return parseMoney(node.textContent) !== null && !looksLikeSavings(node.textContent);
    });
    var savingNodes = nodes.filter(function (node) {
      return looksLikeSavings(node.textContent);
    });

    if (moneyNodes.length < 2) return;

    moneyNodes.sort(function (a, b) {
      return parseMoney(a.textContent) - parseMoney(b.textContent);
    });

    var current = moneyNodes[0];
    var compare = moneyNodes[moneyNodes.length - 1];

    current.dataset.delamurCurrentPrice = 'true';
    compare.dataset.delamurComparePrice = 'true';

    savingNodes.forEach(function (node) {
      node.dataset.delamurSavingPrice = 'true';
    });

    row.dataset.delamurPriceRow = 'true';
    row.dataset.delamurPriceSorted = 'true';
  }

  function normalizeTextSequences(scope) {
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue.match(PRICE_SEQUENCE)) return NodeFilter.FILTER_REJECT;
        if (!node.parentElement || node.parentElement.closest('script, style, input, textarea, button')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var textNodes = [];
    var node = walker.nextNode();

    while (node) {
      textNodes.push(node);
      node = walker.nextNode();
    }

    textNodes.forEach(rewriteInlinePriceText);
  }

  function normalizeStructuredPrices(scope) {
    var candidates = scope.querySelectorAll(
      '[class*="upcart" i] [class*="price" i], [class*="upcart" i] [class*="saving" i], [class*="upcart" i] [class*="discount" i]'
    );

    candidates.forEach(function (candidate) {
      var row = candidate.parentElement;
      for (var i = 0; row && i < 4; i += 1) {
        if (row.textContent && row.textContent.match(/\d+[,.]\d{2}\s*\u20ac/) && row.textContent.match(/ahorra|save|savings/i)) {
          sortPriceNodes(row);
          return;
        }
        row = row.parentElement;
      }
    });
  }

  function normalizeUpcartPrices(root) {
    var scope = root || document;
    normalizeTextSequences(scope);
    normalizeStructuredPrices(scope);
  }

  function init() {
    normalizeUpcartPrices(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          normalizeUpcartPrices(node);
        });
      });
      normalizeUpcartPrices(document);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
